import type{ IGAdminConfig } from "./modules/nuxt3-module-admin-ingang/app.config.value";

const basePath = '/'

//각 프로젝트의 app.config.value.ts 에서 실제 밸류 설정
const appConfig: IGAdminConfig = {
  appId: 'nuxt3-admin-myfirstguide',
  appName: '마이퍼스트가이드-관리자',
  basePath: basePath,
  buildVersion: '1.00-20221215',
  creatorNameKo: '가이드',
  courseNameOnflag03: "트립앤스터디",
  TUTOR: "그림",
  protocol: 'https',
  dbDomain: 'myfirstguide',
  domain: 'www.myfirstguide.com',
  shortHostName: 'myfirstguide',
  siteName: '마이퍼스트가이드',
  jusoApiKey: 'U01TX0FVVEgyMDE1MDgwMzEwMTgwOA==',
  fullDomain: 'https://www.myfirstguide.com',
  fullUrl: 'https://creator.myfirstguide.com' + basePath,
  API_BASE_URL: 'https://api.myfirstguide.com',
  STORAGE_BASE_URL: 'https://storage.myfirstguide.com',
  CASH_NAME: '별캐시',
  BRAND_PAY_NAME: '마퍼가페이',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCywSLkWRbX0rsqmsK8gBbLorXGHM0OJVU',
  // 게이트 E — 어드민 로그인 Turnstile. (2026-08-20 추가)
  // 어드민도 /mer/oauth/login 으로 일원화돼 게이트 E 안에 들어왔는데 위젯이 없어
  // 토큰을 못 만들던 상태였다. 강제 승격 시 관리자 전원 로그인 불가가 되므로 키를 넣는다.
  //
  // 본체(www)와 **같은 위젯**을 쓴다 — Turnstile 은 등록 호스트명의 서브도메인을 자동
  // 포함하므로 apex(myfirstguide.com)만 등록돼 있으면 creator. 도 통과한다.
  // (실측: 2026-08-19 siteverify 가 hostname=www.myfirstguide.com 으로 success=Y)
  //
  // ⚠️ 이 키만으로는 위젯이 뜨지 않는다. 위젯 코드는 nuxt3-module-doyac 의
  //    DYLoginPage.vue 에 있으므로 **그 모듈 동기화가 함께 필요**하다.
  CLOUDFLARE_TURNSTILE_SITE_KEY: '0x4AAAAAAEU6-Sm2b5Imi1tG', // 위젯 myfirstguide-login (관리형)
  IOS_APP_STORE_ID: '1491884677',
  IOS_APP_BUNDLE_ID: 'com.doyac.ios.app.MyFirstGuide',
}

export default appConfig